{
  "rightSidebar": {
    "placeholder": "Tento panel je zástupný obsah.",
    "chat": {
      "placeholder": "Spýtaj sa na tento tréning…"
    },
    "favourites": {
      "empty": "Tvoje najčastejšie cviky sa zobrazia tu, keď si zaznamenáš nejaké tréningy."
    },
    "tabs": {
      "coach": "Tréningový tréner",
      "exercises": "Cviky",
      "favourites": "Obľúbené"
    }
  },
  "title": "Cvičenia",
  "subtitle": "Sledujte svoju fitness cestu",
  "builder": {
    "header": {
      "label": "Cvičenie",
      "selectDate": "Vybrať dátum"
    }
  },
  "status": {
    "planned": "Naplánované",
    "started": "Prebieha",
    "finished": "Dokončené",
    "creating": "Vytvára sa"
  },
  "action": {
    "planned": "Začať",
    "started": "Pokračovať",
    "finished": "Hotovo"
  },
  "progressCount": "{{completed}}/{{total}}",
  "empty": {
    "title": "Žiadne cvičenia naplánované",
    "description": "Začnite svoju fitness cestu vytvorením prvého cvičenia"
  },
  "createWorkout": "Vytvoriť cvičenie",
  "duration": "{{duration}}min",
  "exercises_one": "{{count}} cvik",
  "exercises_few": "{{count}} cviky",
  "exercises_other": "{{count}} cvikov",
  "progress": {
    "title": "Pokrok cvičenia",
    "loading": "Načítavam cvičenie...",
    "workoutNotFound": "Cvičenie nenájdené",
    "comingSoon": "Sledovanie pokroku už čoskoro",
    "setsTitle": "Série cvikov",
    "setsCompleted": "{{done}}/{{total}} dokončených",
    "setShort": "Séria {{number}}",
    "setBadge": "SÉRIA"
  },
  "form": {
    "title": {
      "create": "Vytvoriť nové cvičenie",
      "edit": "Upraviť cvičenie",
      "detail": "Detail cvičenia"
    },
    "fields": {
      "name": {
        "label": "Názov cvičenia",
        "placeholder": "Zadajte názov cvičenia"
      },
      "plannedAt": {
        "label": "Plánovaný dátum",
        "placeholder": "Vybrať dátum"
      },
      "note": {
        "label": "Poznámka",
        "placeholder": "Pridať poznámku..."
      }
    },
    "buttons": {
      "save": "Uložiť cvičenie",
      "cancel": "Zrušiť",
      "create": "Vytvoriť cvičenie",
      "update": "Aktualizovať cvičenie",
      "addExercise": "Pridať cvik",
      "addSuperset": "Pridať superset",
      "startWorkout": "Začať cvičenie",
      "stopWorkout": "Ukončiť cvičenie"
    },
    "validation": {
      "nameRequired": "Názov cvičenia je povinný",
      "dateRequired": "Plánovaný dátum je povinný"
    },
    "datePicker": {
      "selectDate": "Vybrať dátum"
    }
  },
  "deleteConfirmation": {
    "description": "Naozaj chcete vymazať cvičenie '{{name}}'? Túto akciu nie je možné vrátiť späť."
  },
  "stopConfirmation": {
    "title": "Ukončiť cvičenie",
    "description": "Naozaj chcete ukončiť toto cvičenie? Váš pokrok bude uložený."
  },
  "superset": {
    "title": "Superset {{index}}",
    "label": "Superset",
    "moveUp": "Presunúť vyššie",
    "moveDown": "Presunúť nižšie",
    "delete": "Vymazať"
  },
  "sportActivitySelector": {
    "title": "Vybrať cvik",
    "description": "Vyberte cvik na pridanie do cvičenia",
    "searchPlaceholder": "Vyhľadať cviky...",
    "resultsPlaceholder": "Výsledky vyhľadávania sa zobrazia tu",
    "noResults": "Žiadne cviky nenájdené",
    "loading": "Vyhľadávam cviky...",
    "error": "Cviky sa nepodarilo načítať. Skontrolujte pripojenie a skúste to znova.",
    "createCustom": "Vytvoriť vlastnú aktivitu",
    "filters": {
      "all": "Všetky"
    }
  },
  "createActivity": {
    "title": "Vlastná aktivita",
    "subtitle": "Vytvor si vlastný cvik na mieru",
    "fields": {
      "name": {
        "label": "Názov *",
        "placeholder": "napr. Bulharské výpady"
      },
      "category": {
        "label": "Kategória *",
        "placeholder": "Vyberte kategóriu"
      },
      "dimensions": {
        "label": "Sledované metriky",
        "hint": "Vyber 1–3 metriky"
      },
      "muscleTargets": {
        "label": "Cieľové svaly",
        "hint": "Aspoň jeden sval",
        "targetNumber": "Cieľ {{number}}",
        "count_one": "{{count}} sval",
        "count_few": "{{count}} svaly",
        "count_other": "{{count}} svalov"
      },
      "muscleGroup": "Svalová skupina",
      "muscle": "Sval",
      "intensity": "Intenzita"
    },
    "actions": {
      "cancel": "Zrušiť",
      "create": "Vytvoriť aktivitu",
      "addMuscle": "Pridať sval"
    }
  },
  "muscleGroup": {
    "ARMS": "Ruky",
    "LEGS": "Nohy",
    "CHEST": "Hrudník",
    "BACK": "Chrbát",
    "SHOULDERS": "Ramená",
    "CORE": "Trup",
    "CARDIOVASCULAR": "Kardiovaskulárny systém"
  },
  "muscle": {
    "BICEPS": "Biceps",
    "TRICEPS": "Triceps",
    "FOREARMS": "Predlaktia",
    "QUADRICEPS": "Štvorhlavý sval stehna",
    "HAMSTRINGS": "Zadné stehenné svaly",
    "CALVES": "Lýtka",
    "GLUTES": "Sedacie svaly",
    "PECTORALIS_MAJOR": "Veľký prsný sval",
    "PECTORALIS_MINOR": "Malý prsný sval",
    "LATISSIMUS_DORSI": "Široký chrbtový sval",
    "TRAPEZIUS": "Trapézový sval",
    "RHOMBOIDS": "Kosoštvorcové svaly",
    "DELTOIDS": "Deltové svaly",
    "ROTATOR_CUFF": "Rotátorová manžeta",
    "RECTUS_ABDOMINIS": "Priamy brušný sval",
    "OBLIQUES": "Šikmé brušné svaly",
    "LOWER_BACK": "Bedrové svaly",
    "HEART": "Srdce"
  },
  "exercise": {
    "delete": "Vymazať",
    "swap": "Zameniť cvik",
    "moveUp": "Presunúť vyššie",
    "moveDown": "Presunúť nižšie"
  },
  "sets": {
    "title": "Série",
    "setNumber": "Séria {{number}}",
    "noSets": "Zatiaľ neboli pridané žiadne série",
    "loading": "Načítavam série...",
    "error": "Chyba pri načítaní sérií"
  },
  "exerciseSummary": {
    "sets_one": "{{count}} séria",
    "sets_few": "{{count}} série",
    "sets_other": "{{count}} sérií",
    "reps": "opak"
  },
  "dimension": {
    "WEIGHT": {
      "name": "Váha"
    },
    "REPS": {
      "name": "Opakovania"
    },
    "TIME": {
      "name": "Čas"
    },
    "DISTANCE": {
      "name": "Vzdialenosť"
    },
    "CALORIES": {
      "name": "Kalórie"
    },
    "HEART_RATE": {
      "name": "Tep srdca"
    },
    "REST": {
      "name": "Odpočinok"
    }
  },
  "sequence": {
    "title": "Poradie cvičenia",
    "subtitle": "{{count}} séria v poradí",
    "subtitle_plural": "{{count}} sérií v poradí",
    "loading": "Načítavam poradie...",
    "error": "Chyba pri načítaní poradia",
    "empty": "Žiadne série na zobrazenie v poradí",
    "supersetLabel": "Superset {{index}}",
    "exerciseLabel": "Cvik {{index}}",
    "completeSet": "Dokončiť set"
  },
  "exerciseLibrary": {
    "title": "Moje cviky",
    "add": "Pridať",
    "empty": "Zatiaľ žiadne vlastné cviky",
    "custom": "Vlastné"
  },
  "personalRecords": {
    "title": "Osobné rekordy",
    "reps_one": "{{count}} opakovanie",
    "reps_few": "{{count}} opakovania",
    "reps_other": "{{count}} opakovaní",
    "empty": "Zatiaľ žiadne osobné rekordy"
  },
  "stats": {
    "title": "Týždenný súhrn",
    "workouts": "Cvičenia",
    "totalTime": "Celkový čas",
    "caloriesBurned": "Spálené kalórie",
    "weightLifted": "Zdvihnuté kg"
  },
  "history": {
    "title": "História cvičení",
    "thisWeek": "Tento týždeň",
    "today": "Dnes",
    "yesterday": "Včera",
    "empty": "Žiadne cvičenia tento týždeň",
    "add": "Pridať"
  },
  "unit": {
    "BPM": {
      "shortName": "úd./min"
    },
    "H": {
      "shortName": "h"
    },
    "KCAL": {
      "shortName": "kcal"
    },
    "KG": {
      "shortName": "kg"
    },
    "KM": {
      "shortName": "km"
    },
    "LB": {
      "shortName": "lb"
    },
    "M": {
      "shortName": "m"
    },
    "MI": {
      "shortName": "míľ"
    },
    "MIN": {
      "shortName": "min"
    },
    "NONE": {
      "shortName": ""
    },
    "S": {
      "shortName": "sek"
    }
  },
  "summary": {
    "title": "Skvelá práca!",
    "subtitle": "{{name}} úspešne dokončený",
    "stats": {
      "title": "Štatistiky cvičenia",
      "volume": "Objem záťaže",
      "volumeCaption": "Σ (sety × opakovania × váha)",
      "duration": "Čas cvičenia",
      "durationUnit": "minút"
    },
    "units": {
      "kg": "kg"
    },
    "difficulty": {
      "title": "Ako náročné to bolo?",
      "levels": {
        "easy": "Ľahké",
        "ok": "OK",
        "right": "Správne",
        "hard": "Ťažké",
        "max": "Max"
      }
    },
    "note": {
      "title": "Poznámka k cvičeniu",
      "placeholder": "Ako sa cítim po cvičení, čo by som mohol zlepšiť…"
    },
    "done": "Späť na prehľad"
  },
  "duplicate": {
    "action": "Duplikovať",
    "actionsLabel": "Akcie tréningu",
    "modal": {
      "title": "Duplikovať tréning",
      "description": "Vyber dátum pre nový naplánovaný tréning. Kópia zachová každý cvik a sériu s naplánovanými hodnotami.",
      "dateLabel": "Naplánovaný dátum",
      "confirm": "Duplikovať",
      "cancel": "Zrušiť"
    },
    "toast": {
      "title": "Tréning duplikovaný",
      "description": "'{{name}}' bol pridaný do tvojho plánu."
    }
  },
  "recorded": {
    "effort": "Zaznamenané úsilie",
    "avgHr": "Priemerný tep",
    "maxHr": "Maximálny tep",
    "calories": "Kalórie",
    "fromSource": "Tep a kalórie z {{source}}",
    "sourceAppleHealth": "Apple Health",
    "sourceHealthConnect": "Health Connect",
    "match": {
      "confirmTitle": "Priložiť zaznamenané cvičenie?",
      "confirmSubtitle": "Našli sme aktivitu, ktorá sa prekrýva s týmto cvičením.",
      "pickTitle": "Ktoré cvičenie to bolo?",
      "pickSubtitle": "S týmto cvičením sa prekrýva viac aktivít — vyber tú správnu.",
      "attach": "Priložiť",
      "attachSelected": "Priložiť vybrané",
      "notNow": "Teraz nie",
      "range": "{{start}}–{{end}} · {{minutes}} min",
      "bpm": "{{bpm}} bpm",
      "kcal": "{{kcal}} kcal"
    }
  }
}
